<template>
  <div class="my-order">
    <mt-cell title="我的订单"  @click.native="entoMyOrder(0)">
      <span>查看全部</span><van-icon name="arrow" class="arrowIcon" />
    </mt-cell>
    <div class="order-tab">
      <div class="order-tab-item click-active" @click="entoMyOrder(1)">
        <div class="oti-img">
          <div class="icon iconfont icon-gouwuche1"></div>
          <soho-badge :number="waitFinishBadge" class="my-badge"></soho-badge>
        </div>
        <span>待完成</span>
      </div>
      <div class="order-tab-item click-active" @click="entoMyOrder(2)">
        <div class="oti-img">
          <div class="icon iconfont icon-shouhuo"></div>
          <soho-badge :number="waitReceiveBadge" class="my-badge"></soho-badge>
        </div>
        <span>待收货</span>        
      </div>
      <div class="order-tab-item click-active" @click="entoMyOrder(3)">
        <div class="oti-img">
          <div class="icon iconfont icon-yiwancheng"></div>
        </div>
        <span>已完成</span>
      </div>
      <div class="order-tab-item click-active" @click="invitationEvaluate">
        <div class="oti-img">
          <div class="icon iconfont icon-pingjia"></div>
          <soho-badge :number="waitEvaluateBadge" class="my-badge"></soho-badge>
        </div>
        <span>待评价</span>        
      </div>
      <div class="order-tab-item click-active" @click="entoHasRefund">
        <div class="oti-img">
          <div class="icon iconfont icon-tuikuan"></div>
        </div>
        <span>已退款</span>
      </div>      
    </div>
  </div>
</template>

<script>
import { Icon } from "vant";
export default {
  data () {
    return {
    }
  },
  props: {
    waitFinishBadge: {
      type: Number,
      default: 0
    },
    waitReceiveBadge: {
      type: Number,
      default: 0
    },
    waitEvaluateBadge: {
      type: Number,
      default: 0
    }
  },
  components: {
    "van-icon": Icon
  },
  methods: {
    entoMyOrder (index) {
      this.$emit('entoMyOrder', index)
    },
    entoHasRefund () {
      this.$emit('entoHasRefund')
    },
    invitationEvaluate () {
      this.$emit('invitationEvaluate')
    }
  }
}
</script>

<style scoped>
  .click-active:active{
    background: #f2f2f2;
  }
  .my-order{
    margin-top: 2%;
    text-align: left;
  }
  .my-order >>> .mint-cell-wrapper{font-size: 14px;}
  .my-order >>> .mint-cell-wrapper{background-image: none;}
  .my-order >>> .mint-cell-wrapper{padding-left: 15px;}
  .my-order >>> .mint-cell-text{
    font-size: 15px;
    font-weight: 700;
  }
  .order-tab{
    display: flex;
    flex-direction: row;
    align-items: center;
    background: #fff;
    font-size: 14px;
  }
  .order-tab-item{
    flex: 1;
    position: relative;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 2% 0 5%;
  }
  .oti-img{
    position: relative;
    width: 2em;
    height: 2em;
    margin-bottom: 2%;
    line-height: 2em;
    text-align: center;
  }
  .oti-img .icon{
    font-size: 22px;
  }
  .my-badge{
    position: absolute;
    top: -10%;
    right: 0;
    transform: translateX(100%);
  }
</style>
